import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  addPlaceLoading: false,
  addPlaceSuccess: false,
  addPlaceError: null,
};

const placeSlice = createSlice({
  name: "place",
  initialState: INITIAL_STATE,
  reducers: {
    addPlaceStart: (state) => {
      return {
        ...state,
        addPlaceLoading: true,
        addPlaceError: null,
      };
    },
    addPlaceSuccess: (state) => {
      return {
        ...state,
        addPlaceLoading: false,
        addPlaceSuccess: true,
      };
    },
    addPlaceError: (state, { payload: { error } }) => {
      return {
        ...state,
        addPlaceLoading: false,
        addPlaceError: error,
      };
    },
    clearAddPlace: (state) => {
      return {
        ...state,
        addPlaceSuccess: false,
        addPlaceError: null,
      };
    },
  },
});

export const { addPlaceStart, addPlaceSuccess, addPlaceError, clearAddPlace } =
  placeSlice.actions;

export default placeSlice.reducer;
